import React, { Component } from 'react';
import TextEditDataProcesser, { ITextEditItemsData } from './textEditDataProcesser';
import TextStyleItems from './text-style';
import FontSizeItem from './font-size';
import ColorEditItems from './color-edit';
import { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import { ColorPanelType } from '@com-m/edit-panel-m/const';
import { IColorPickerManager } from '@src/slide/application/service/color-picker-manager/color-picker-manager.interface';

interface IEditPanelProps {
    itemDatas: Array<object>;
    menuManager?: IMenuManager;
    colorPickerManager?: IColorPickerManager;
    openColorPanel(type: ColorPanelType): void;
}
interface IEditPanelStates {
    textEditData: ITextEditItemsData;
}
export default class TextEditItems extends Component<IEditPanelProps, IEditPanelStates> {
    public constructor(props) {
        super(props);
        this.state = {
            textEditData: {
                editFontItemsData: [],
                editAlignItemsData: [],
                editItemNumberItemsData: [],
                editFontSize: [],
                editFontColor: {},
                editFillColor: {},
                editBorderColor: {},
            },
        };
    }
    public render() {
        const { itemDatas } = this.props;
        const textEditData = TextEditDataProcesser.getTextEditItemsData(itemDatas);
        return <React.Fragment>
            <TextStyleItems textEditData={textEditData} menuManager={this.props.menuManager}/>
            <FontSizeItem textEditData={textEditData} menuManager={this.props.menuManager}/>
            <ColorEditItems
                colorPickerManager={this.props.colorPickerManager}
                textEditData={textEditData}
                openColorPanel={this.props.openColorPanel}
            />
        </React.Fragment>;
    }
}
